export interface blankState {
  isCommentsEmpty: boolean;
}

export const emptyBlankState: blankState = {
  isCommentsEmpty: false,
}